<template>
  <div class="courseBox">
    <div class="nav" v-if="type=='volunteer'">
      <ul>
        <li
          v-for="(item, index) in nav"
          :key="index"
          :class="navIndex == index ? 'active' : ''"
          @click="navIndex = index"
        >
          {{ item.name }}
        </li>
      </ul>
    </div>
    <div class="filter" v-if="from == 'agency' && type == 'online' && courseList.length">
      <ul>
        <li
          v-for="(item, index) in typeList"
          :key="index"
          :class="typeIndex == index ? 'active' : ''"
          @click="typeIndex = index"
        >
          {{ item.classcodename }}
        </li>
      </ul>
    </div>
    <div
      class="courseList"
      :style="{ marginTop: type == 'online' ? 0 : '16px' }"
    >
      <mescroll-vue
        ref="mescroll"
        :down="mescrollDown"
        :up="mescrollUp"
        @init="mescrollInit"
      >
        <ul :class="from == 'volunteer' && type == 'online'?'margin':''" v-if="courseList.length > 0 && getData">
          <li
            v-for="(item, index) in courseList"
            :key="index"
            @click="goCourse(item)"
          >
            <Components
              :type="type=='online'?'course':'training'"
              :data="item"
              :otherData="{ showTeacher: type == 'agency' }"
            ></Components>
          </li>
        </ul>
        <div class="notDataBox" v-if="courseList.length == 0 && getData">
          <NotData :className="type" :title="`暂无${type=='online'?'线上课程':'线下培训'}信息`"></NotData>
        </div>
      </mescroll-vue>
    </div>
  </div>
</template>

<script>
import NotData from "@/components/notData";
import Components from "./components/components.vue";
import MescrollVue from "mescroll.js/mescroll.vue";

export default {
  name: "courseBox",
  metaInfo() {
    return {
      title: this.type? this.type == 'online'?'线上课程':'线下培训':"全部老师",
    };
  },
  data() {
    return {
      navIndex: 0,
      teaminfoid: "",
      type: "", // online;traning
      from: '', //volunteer老师  agency团体
      nav: [
        { name: "全部", value: "1000", typeValue: "1000" },
        { name: "在线课程", value: "1000", typeValue: "1002" },
        { name: "面授课程", value: "2000", typeValue: "1001" },
      ],
      typeList: [{ classcodename: "全部", classcodeid: "" }],
      typeIndex: 0,
      courseList: [],
      getData: false,
      mescroll: null, // mescroll实例对象
      mescrollDown: {
        auto: false,
        callback: this.downCallback,
      },
      mescrollUp: {
        callback: this.upCallback, // 上拉回调,此处可简写; 相当于 callback: function (page, mescroll) { getListData(page); }
        //以下是一些常用的配置,当然不写也可以的.
        htmlNodata: "",
        page: {
          num: 0,
          size: 10,
        },
        noMoreSize: 5, //如果列表已无数据,可设置列表总数大于5才显示无更多数据;避免列表数据过少(比如只有一条数据),显示无更多数据会不好看
        empty: {
          //列表第一页无任何数据时,显示的空提示布局; 需配置warpId才显示
          // warpId: "xxid", //父布局的id (1.3.5版本支持传入dom元素)
          //icon: "./static/mescroll/mescroll-empty.png", //图标,默认null,支持网络图
          // warpId: "#list",
          // icon: "@/assets/img/index/noContent.png",
          //tip: "暂无其他头条内容",
        },
      },
    };
  },
  components: {
    NotData,
    Components,
    MescrollVue,
  },
  watch: {
    ["navIndex"]() {
      this.getType();
    },
    ["typeIndex"]() {
      this.downCallback();
    },
  },
  created() {
    this.id = this.$route.query.id;
    this.type = this.$route.query.type ? this.$route.query.type : "agency";
    this.from  = this.$route.query.from ? this.$route.query.from : ''
    if (this.type == "online") {
      this.getType();
    }
  },
  mounted() {},
  methods: {
    getType() {
      this.typeIndex = 0;
      this.typeList.length = 1;
      var obj = {
        // businessid: this.id,
        // businesstype: this.nav[this.navIndex].typeValue,
        organizationid: this.id
      };
      this.$post(
        "/gart-common-api/api/scm/course/queryByCourseCode",
        obj
      ).then((res) => {
        if (res.code == 1) {
          var data = res.data ? res.data : [];
          this.typeList = this.typeList.concat(data);
          // this.downCallback();
        } else {
          this.util.toast({ msg: res.message });
        }
      });
    },
    mescrollInit(mescroll) {
      this.mescroll = mescroll;
    },
    downCallback() {
      this.getData = false;
      this.mescroll.resetUpScroll();
    },
    upCallback(page, mescroll) {
      this.getListDataFromNet(page.num, page.size, mescroll);
    },
    getListDataFromNet(num, size, mescroll) {
      if (num == 1) {
        this.courseList = [];
      }
      var obj = {
        pageNum: num,
        pageSize: size,
        coursetype : this.type == 'online'? '1000': '2000'
      };
      var url = "";
      switch (this.from) {
        case "agency":
          url  = '/gart-common-api/api/scm/course/queryOrganizationCoursForEs'
          obj.lclasscode = this.typeList[this.typeIndex].classcodeid;
          obj.organizationid = this.id;
          obj.teacherid = ''
          obj.type = '2000'
          
          // url = "/gart-common-api/api/scm/course/queryOrganizationCoursForEs";
          // obj.organizationid = this.id;
          // obj.type = 2000;
          // obj.classcodeid = this.typeList[this.typeIndex].classcodeid;
          break;
        case "volunteer":
          url = "/gart-common-api/api/scm/course/queryCourseForEs";
          obj.teacherid = this.id;
          obj.type = 1000;
          break;
        default:
          break;
      }
      this.$post(url, obj).then((res) => {
        this.getData = true;
        if (res.code == 1) {
          var data = res.data && res.data.rows ? res.data.rows : [];
          this.courseList = this.courseList.concat(data);
          this.$nextTick(() => {
            mescroll.endSuccess(data.length);
          });
        } else {
          this.util.toast({ msg: res.message });
        }
      });
    },
    goCourse(data) {
      var url = "",
        obj = {};
      if (data.coursetype == 2000) {
        url = "/h5/course/belowCourseDetails";
        obj.adjcourseid=data.courseid;
      } else if (data.coursetype == 1001) {
        url = "/h5/course/payCourseDetails";
        obj.courseid=data.courseid;
      } else if (data.coursetype == 1000) {
        url = "/h5/course/publicCourseDetails";
        obj.courseid=data.courseid;
      }
      if (url) {
        this.$router.push({
          path: url,
          query: obj,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.courseBox {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  .nav {
    border-bottom: 0.5px solid rgba(151, 151, 151, 0.2);
    padding: 6px 16px 0;
    li {
      display: inline-block;
      font-size: 16px;
      line-height: 22px;
      color: rgba(45, 45, 45, 1);
      padding: 10px 0;
      margin-right: 24px;
      font-weight: 300;
    }
    li.active {
      font-weight: bolder;
      position: relative;
    }
    li.active::before {
      content: " ";
      display: inline-block;
      width: 20px;
      height: 4px;
      position: absolute;
      left: 50%;
      bottom: 0;
      margin-left: -10px;
      background: rgba(201, 76, 76, 1);
      border-radius: 2px;
    }
  }
  .filter {
    margin: 16px 0;
    ul {
      color: rgba(87, 87, 87, 1);
      white-space: nowrap;
      overflow: auto;
      padding: 0 16px;
      li {
        display: inline-block;
        font-size: 14px;
        line-height: 20px;
        padding: 6px 10px;
        border-radius: 16px;
        border: 0.5px solid rgba(213, 213, 213, 1);
        margin-right: 10px;
        background: #fff;
        font-weight: 300;
      }
      li.active {
        color: rgba(201, 76, 76, 1);
        font-weight: bolder;
        background: rgba(255, 251, 251, 1);
        border-color: rgba(201, 76, 76, 1);
      }
    }
  }
  .courseList {
    flex: 1;
    overflow: hidden;
    ul {
      li {
        margin: 0 16px 16px;
      }
    }
  }
}
.notDataBox {
  margin-top: 200px;
}
.margin {
  margin-top: 16px;
}
</style>